import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Rugs = createSvgIcon(
  <path d="M16.875 0c-.621 0-1.125.504-1.125 1.125V3H0v2.25h3v3H0v2.25h3v3H0v2.25h3v3H0V21h15.75v1.875c0 .621.504 1.125 1.125 1.125h6c.621 0 1.125-.504 1.125-1.125V1.125C24 .504 23.496 0 22.875 0h-6Zm4.875 15.75H18v-7.5h3.75v7.5Zm-6-10.5v13.5H5.25V5.25h10.5ZM18 18h3.75v3.75H18V18Zm3.75-15.75V6H18V2.25h3.75Z" />,
  'Rugs'
);

export { Rugs };